export var PlayerSex;
(function (PlayerSex) {
    PlayerSex["male"] = "male";
    PlayerSex["female"] = "female";
})(PlayerSex || (PlayerSex = {}));
export var PlayerRace;
(function (PlayerRace) {
    PlayerRace["white"] = "white";
    PlayerRace["mulatto"] = "mulatto";
    PlayerRace["black"] = "black";
})(PlayerRace || (PlayerRace = {}));
export var AvatarImageExtensions;
(function (AvatarImageExtensions) {
    AvatarImageExtensions["png"] = "png";
    AvatarImageExtensions["gif"] = "gif";
})(AvatarImageExtensions || (AvatarImageExtensions = {}));
export var HairColorTypes;
(function (HairColorTypes) {
    HairColorTypes["blonde"] = "blonde";
    HairColorTypes["red"] = "red";
    HairColorTypes["orange"] = "orange";
    HairColorTypes["brown"] = "brown";
    HairColorTypes["black"] = "black";
    HairColorTypes["purple"] = "purple";
    HairColorTypes["green"] = "green";
    HairColorTypes["blue"] = "blue";
    HairColorTypes["pink"] = "pink";
})(HairColorTypes || (HairColorTypes = {}));
export var RequestTypes;
(function (RequestTypes) {
    RequestTypes["hintCross"] = "hintCross";
    RequestTypes["translations"] = "translations";
    RequestTypes["init"] = "init";
    RequestTypes["settings"] = "settings";
    RequestTypes["settingsPut"] = "settingsPut";
    RequestTypes["updateParams"] = "updateParams";
    RequestTypes["saveResults"] = "saveResults";
    RequestTypes["log"] = "log";
    RequestTypes["saveTrainingResults"] = "saveTrainingResults";
    RequestTypes["saveBetweenResults"] = "saveBetweenResults";
    RequestTypes["tutorial"] = "tutorial";
})(RequestTypes || (RequestTypes = {}));
export var RequestLogTypes;
(function (RequestLogTypes) {
    RequestLogTypes["start"] = "start";
    RequestLogTypes["end"] = "end";
    RequestLogTypes["error"] = "error";
})(RequestLogTypes || (RequestLogTypes = {}));
export var RedirectDataTypes;
(function (RedirectDataTypes) {
    RedirectDataTypes["mode"] = "mode";
    RedirectDataTypes["disciplineID"] = "discipline_id";
    RedirectDataTypes["reportID"] = "report_id";
    RedirectDataTypes["redirect"] = "redirect";
    RedirectDataTypes["tournamentId"] = "tournament_id";
    RedirectDataTypes["tournamentType"] = "tournament_type";
})(RedirectDataTypes || (RedirectDataTypes = {}));
//# sourceMappingURL=index.js.map